<template>
  <ul class="select" v-outer-click="{ func: closeSelect }">
    <li class="select__label" v-if="label">{{ label }}</li>
    <div class="select__container">
      <button
        class="select__btn"
        @click="showSelect"
        :class="{ show: isShow, normal: title_style }"
      >
        <span>{{ selectedOption }}</span>
        <img src="../images/utils/arrow-select.svg" />
      </button>

      <ul class="select__option" :class="{ show: isShow }">
        <li v-for="(option, index) in options" :key="index">
          <a
            href=""
            class="select__option-item"
            @click.stop.prevent="changeOption(option)"
            >{{ option }}</a
          >
        </li>
      </ul>
    </div>
  </ul>
</template>

<script>
import OuterClick from "../common/outer-click";

export default {
  name: "dropdown",
  props: ["options", "title", "label", "title_style", "cur_value"],
  directives: { OuterClick },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    selectedOption() {
      return this.cur_value || this.title;
    },
  },
  methods: {
    showSelect() {
      this.isShow = !this.isShow;
    },
    closeSelect() {
      this.isShow = false;
    },
    changeOption(option) {
      this.showSelect();
      this.$emit("change", option);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.select {
  width: 100%;
  list-style: none;

  &__container {
    position: relative;
  }

  $height: 52px;
  $dropdown-top: $height;

  &__label {
    margin-bottom: 10px;
    font-size: 14px;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: $height;
    padding: 0 20px;
    border: 1px solid #808080;
    background-color: transparent;
    font-size: 16px;
    font-weight: normal;
    line-height: 30px;
    //text-transform: uppercase;
    color: #000;
    cursor: pointer;
    user-select: none;

    &.normal {
      font-weight: normal;
    }

    img {
      transition: all 0.2s ease;
      margin-left: 15px;
    }

    &.show {
      img {
        transform: rotate(180deg);
      }
    }
  }

  &__option {
    position: absolute;
    left: 0;
    right: 0;
    top: $dropdown-top;
    max-height: 200px;
    overflow-y: auto;
    background-color: #fff;
    //border: 1px solid #bfc2c4;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
    z-index: 10;
    list-style: none;
    font-size: 16px;
    text-align: left;
    padding: 10px 0;
    transform: translateY(-50%) scaleY(0);
    transition: all 0.3s ease;
  }

  &__option.show {
    transform: translateY(0) scaleY(1);
  }

  &__option-item {
    display: block;
    cursor: pointer;
    padding: 10px;
    transition: all 0.2s ease;

    &:hover {
      color: #fff;
      background-color: rgb(191, 194, 196);
    }

    &:focus {
      color: #fff;
      background-color: rgb(191, 194, 196);
    }
  }
}

.select__option.large {
  height: 300px;
  overflow-y: auto;
}

@media (max-width: 1200px) {
  .select {
    &__btn {
      height: 40px;
    }

    &__option {
      top: 40px;
    }
  }
}
</style>